import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const Jobs = () => {
  const L = useLanguage();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    jobType: 'ALL',
  });
  const [query, setQuery] = useState('marketing jobs in chicago');  // Default query

  const fetchJobs = async () => {
    setLoading(true);  // Set loading state to true when fetching
    const options = {
      method: 'GET',
      url: 'https://jsearch.p.rapidapi.com/search',
      params: {
        query: query,  // Use dynamic query
        page: page.toString(),
        num_pages: '1',
        country: 'us',
        date_posted: 'week',
        employment_types: 'FULLTIME'
      },
      headers: {
        'x-rapidapi-key': 'fb0e9e50aamshc485fdeb648badap1c04d4jsnaef19dc42bb0',
        'x-rapidapi-host': 'jsearch.p.rapidapi.com',
      },
    };

    try {
      const response = await axios.request(options);
      if (response.data && response.data.data) {
        setJobs(response.data.data);
        setLoading(false);  // Set loading state to false after data is fetched
      } else {
        setError(L.jobs.noJobs);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setError(L.jobs.loadFailed);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [page, filters, query]);  // Fetch jobs whenever page, filters, or query changes

  const handleJobTypeChange = (event) => {
    setFilters({ ...filters, jobType: event.target.value });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleQueryChange = (event) => {
    setQuery(event.target.value);  // Update the query as user types
  };

  return (
    <>
      <div className="container my-12 pb-12">
        <div className="text-center">
          <div style={{
            fontFamily: "'Dancing Script', cursive",
            fontSize: '1.5rem',
            color: '#ff69b4',
            textShadow: '2px 2px 4px rgba(255, 182, 193, 0.7)',
            padding: '20px',
            background: 'linear-gradient(135deg, #fff0f5 0%, #ffe4e1 100%)',
            borderRadius: '20px',
            border: '3px dashed #ffb6c1',
            margin: '20px auto',
            maxWidth: '400px',
            position: 'relative'
          }}>
            <span style={{ fontSize: '1.5rem' }}>🌸</span>
            <span style={{ margin: '0 10px' }}>✿</span>
            {L.jobs.greeting}
            <span style={{ margin: '0 10px' }}>✿</span>
            <span style={{ fontSize: '1.5rem' }}>🌸</span>
            <div style={{ fontSize: '1.2rem', marginTop: '5px' }}>
              🌷💐🌺💮🌻🌼
            </div>
          </div>
          <h1 className="pt-4" style={{ color: '#635bff', fontWeight: '700' }}>
            <strong>{L.jobs.title}</strong>
          </h1>

          {/* Search Query Input */}
          <div className="mb-3">
            <label htmlFor="jobQuery" className="form-label" style={{ color: '#425466', fontWeight: '500' }}>
              {L.jobs.searchLabel}
            </label>
            <input
              type="text"
              className="form-control"
              id="jobQuery"
              value={query}
              onChange={handleQueryChange}  // Update query on change
              placeholder={L.jobs.searchPlaceholder}
              style={{
                border: '1px solid #e6e6e6',
                borderRadius: '8px',
                padding: '12px 16px',
                fontSize: '14px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                transition: 'border-color 0.15s ease, box-shadow 0.15s ease'
              }}
            />
          </div>

          {/* Job Type Filter */}
          
        </div>

        {/* Loading/Error */}
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status" style={{ color: '#635bff' }}>
              <span className="visually-hidden">{L.common.loading}</span>
            </div>
          </div>
        ) : error ? (
          <div className="text-center" role="alert" style={{
            backgroundColor: '#fef2f2',
            color: '#dc2626',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #fecaca'
          }}>
            {error}
          </div>
        ) : (
          <div>
            {/* Job Listings */}
            {jobs.length > 0 ? (
              jobs.map((job, index) => (
                <div key={index} className="mb-3" style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  border: '1px solid #e6e6e6',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                  overflow: 'hidden'
                }}>
                  <div style={{ padding: '24px' }}>
                    <h5 style={{ color: '#0a2540', fontWeight: '600', marginBottom: '12px' }}>{job.job_title}</h5>
                    <p style={{ color: '#425466', marginBottom: '8px' }}><strong>{L.jobs.company}</strong> {job.employer_name}</p>
                    <p style={{ color: '#425466', marginBottom: '16px' }}><strong>{L.jobs.location}</strong> {job.job_location}</p>
                    <a 
                      href={job.job_apply_link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      style={{
                        backgroundColor: '#635bff',
                        color: '#ffffff',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        textDecoration: 'none',
                        fontWeight: '500',
                        fontSize: '14px',
                        display: 'inline-block',
                        transition: 'background-color 0.15s ease'
                      }}
                    >
                      {L.jobs.applyHere}
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#425466', textAlign: 'center' }}>{L.jobs.noJobs}</p>
            )}

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: '24px' }}>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page <= 1}
                style={{
                  backgroundColor: page <= 1 ? '#f0f0f0' : '#ffffff',
                  color: page <= 1 ? '#a0a0a0' : '#0a2540',
                  border: '1px solid #e6e6e6',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  fontWeight: '500',
                  cursor: page <= 1 ? 'not-allowed' : 'pointer',
                  transition: 'all 0.15s ease'
                }}
              >
                {L.jobs.previous}
              </button>
              <span style={{ color: '#425466', fontWeight: '500' }}>{L.jobs.pageN(page)}</span>
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={jobs.length === 0}
                style={{
                  backgroundColor: jobs.length === 0 ? '#f0f0f0' : '#635bff',
                  color: jobs.length === 0 ? '#a0a0a0' : '#ffffff',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  fontWeight: '500',
                  cursor: jobs.length === 0 ? 'not-allowed' : 'pointer',
                  transition: 'all 0.15s ease'
                }}
              >
                {L.jobs.next}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Jobs;
